import React from 'react';


const userSelect = ({ chatMenu, onSelectUser }) => {
    const optionList = [...(chatMenu.chat_option && Object.keys(chatMenu.chat_option[0] || {}) || []).map((el, index) => ({
        name: chatMenu.chat_option[0][el],
        id: +el
    })) || [], ...chatMenu.bidders || [], ...chatMenu.non_bidders || [],]
    return (
        <>
            <div className='pt-5 pb-5 fs-12 tCenter border-top-light bg-light-yellow'>Who can see your messages?</div>
            <div className='mt-5 mb-5 fs-14 pl-5 fSemiBold'>
                <label for="to">To: </label>
                <select name="chat-user-select" id="chat-user-select" className='select' onChange={onSelectUser}>
                    {(optionList || []).map(el => (
                        <option value={el.id}>{el.name}</option>
                    ))}
                </select>
            </div>
        </>
    )
}

export default userSelect;